export default "__VITE_ASSET__b26e8670__"